import { LogOut } from "lucide-react";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogoutClick = () => {
    setIsModalOpen(true);
  };

  const confirmLogout = () => {
    setIsModalOpen(false);
    navigate("/login");
  };

  const cancelLogout = () => {
    setIsModalOpen(false);
  };

  const modalContent = (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Confirm Sign Out
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to sign out?
        </p>
        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200"
            onClick={cancelLogout}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-all duration-200"
            onClick={confirmLogout}
          >
            Yes, Sign Out
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <button
        className="w-full mt-2 px-4 py-2.5 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-all duration-200 flex items-center justify-center shadow-sm"
        onClick={handleLogoutClick}
      >
        <LogOut className="w-5 h-5 mr-2" />
        Sign Out
      </button>
      {isModalOpen && createPortal(modalContent, document.body)}
    </>
  );
};

export default Logout;
